import request from '@/utils/request';
import { newHost } from '@/global-config';

export function listTransDetail(data) {
  return request({
    url: '/trans/listTransDetailV2',
    method: 'post',
    data,
  });
}

export function listAllTransToolByMerchantId(params) {
  return request({
    // url: '/transTool/listAllTransToolByMerchantId',
    url: '/transTool/listTransToolByMerchantIdAndDeviceType',
    method: 'get',
    params,
  });
}

export function fetchCashiers(data) {
  return request({
    url: '/merchant-info/listCashierArea',
    method: 'post',
    data,
  });
}
export function getOrderAvailableAmount(id) {
  return request({
    url: '/trans/getOrderAvailableAmount',
    method: 'get',
    params: { leshuaOrderId: id },
  });
}

export function checkBusinessVerifyCode(data) {
  return request({
    url: '/trans/orderRefund',
    method: 'post',
    data,
  });
}

/* 获取商户门店列表 */
export function queryShopList(data) {
  return request({
    url: '/shop/listPage',
    method: 'post',
    data,
    baseURL: newHost,
  });
}

/* 获取商户收银点列表 */
export function queryCashierList(data) {
  return request({
    url: '/cashierArea/list',
    method: 'post',
    data,
    baseURL: newHost,
  });
}

/* 获取商户收款设备列表 */
export function queryDeviceList(data) {
  return request({
    url: '/device/list',
    method: 'post',
    data,
    baseURL: newHost,
  });
}

/* 获取商户交易数据列表 */
export function queryTransactionList(data) {
  return request({
    url: '/transaction/list',
    method: 'post',
    data,
    baseURL: newHost,
  });
}

/* 获取商户交易数据详情 */
export function queryTransactionDetail(data) {
  return request({
    url: '/transaction/detail',
    method: 'post',
    data,
    baseURL: newHost,
  });
}

/* 获取商户退款数据详情 */
export function queryTransactionRefundInf(data) {
  return request({
    url: '/transaction/refundInfo',
    method: 'post',
    data,
    baseURL: newHost,
  });
}

/* 申请导出交易列表数据 */
export function applyDownloadTableData(data) {
  return request({
    url: '/transaction/download',
    method: 'post',
    data,
    baseURL: newHost,
  });
}
